module.exports = __webpack_public_path__ + "img/pricing_icon.3c05e4af.png";